module.exports = __webpack_public_path__ + "img/pinterest.bd8a12db.svg";